import { network } from "@/config";
import { changeNetwork, networkDomains } from "@/lib/network";
import { capitalizeFirst } from "@/lib/utils";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Link } from "../links";

export function NetworkSettings() {
  const onValueChange = (value: string) => {
    changeNetwork(capitalizeFirst(value))
  };
  const prettyNetwork = capitalizeFirst(network)
  return (
    <>
      <h4>Current network: {prettyNetwork}</h4>
      <ToggleGroup
        type="single"
        variant="outline"
        onValueChange={onValueChange}
        value={network}
        className="gap-3 mb-4"
      >
        {Object.entries(networkDomains).map(([name]) => (
          <ToggleGroupItem
            className="border rounded-md flex flex-col w-24 h-24"
            value={name.toLowerCase()}
          >
            <span className="text-xl">{name.slice(0, 1)}</span>{" "}
            <span>{name}</span>
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      <p className="text-sm">
        Testing networks like Testnet and Fnet do not use real-value currencies.
        Their use case is exclusively for testing new Myth features.
      </p>
      <p className="text-sm text-muted-foreground">
        Testnet allows usage of Pera and Defly wallets.
      </p>
      <p className="text-sm text-muted-foreground">
        Fnet is used primarily to test dualSTAKE.
      </p>
      <div className="hidden md:flex grow"></div>
      <p className="text-sm text-muted-foreground">
        Backup mainnet deployment available at <Link to="https://backup.myth.finance">backup.myth.finance</Link>.
      </p>
    </>
  );
}
